import { createSelector } from 'reselect';
import { WorkflowsRootState } from '../ducks.types';

export const getModals = (state: WorkflowsRootState) => state.workflow?.modals || {};
export const selectOpenModalsList = createSelector([getModals], (modals) => Object.entries(modals));
